import { createSettingsDeliverableTypesRoutes } from './deliverable-types/routes';
import { createSettingsServiceTypesRoutes } from './service-types/routes';
import { createSettingsSubscriptionRoutes } from './subscription/routes';
import { createSettingsTeamRoutes } from './team/routes';
import { createSettingsTermsAndConditionsRoutes } from './terms-and-conditions/routes';
import { createSettingsWorkspaceRoutes } from './workspace/routes';

export const createSettingsRoutes = (basePath: string) =>
  ({
    index: basePath,
    deliverableTypes: createSettingsDeliverableTypesRoutes(
      `${basePath}/deliverable-types`,
    ),
    serviceTypes: createSettingsServiceTypesRoutes(`${basePath}/service-types`),
    subscription: createSettingsSubscriptionRoutes(`${basePath}/subscription`),
    team: createSettingsTeamRoutes(`${basePath}/team`),
    termsAndConditions: createSettingsTermsAndConditionsRoutes(
      `${basePath}/terms-and-conditions`,
    ),
    workspace: createSettingsWorkspaceRoutes(`${basePath}/workspace`),
  }) as const;
